export const timelineDefaultContent = {
    en: {
        timelineTexts: {
            0: {
                subheading: '500 BCE',
                heading: 'Birth of Mindfulness in Buddhism',
                text: 'Buddha introduced mindfulness as a path to enlightenment, emphasizing awareness without judgment. This laid the foundation for mindfulness meditation globally.'
            },
            1: {
                subheading: '1979 CE',
                heading: 'MBSR\'s Inception',
                text: 'Dr. Jon Kabat-Zinn launched the MBSR program at the University of Massachusetts. This pivotal step popularized mindfulness in the West, blending Eastern practices with Western therapies.'
            }
        }
    },
    es: {
        timelineTexts: {
            0: {
                subheading: '500 A. C.',
                heading: 'Nacimiento de la atención plena en el budismo',
                text: 'Buda introdujo la atención plena como un camino hacia la iluminación, enfatizando la conciencia sin juicio. Esto sentó las bases para la meditación de atención plena a nivel mundial.'
            },
            1: {
                subheading: '1979 CE',
                heading: 'El origen de MBSR',
                text: 'El Dr. Jon Kabat-Zinn lanzó el programa MBSR en la Universidad de Massachusetts. Este paso fundamental popularizó la atención plena en Occidente, combinando prácticas orientales con terapias occidentales.'
            }
        }
    }
}
